import { SxProps, Theme } from "@mui/material";

export const MapSx: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  flexGrow: "1"
}
